import { createContext, PropsWithChildren, useContext } from "react";
import { JavaCurrencyValue } from "../../utils";

export type RecentSearchHotelPropertyResponse = {
  recentlySearchedHotels?: Array<RecentSearchHotelPropertyItem>;
};

export type RecentSearchHotelPropertyItem = {
  hotelId: string;
  image: string;
  price: JavaCurrencyValue;
  hotelName: string;
  location: string;
  isFrequentlyBooked: boolean;
};

const RecentlyViewedHotelsContext =
  createContext<RecentSearchHotelPropertyResponse | null>(null);

export default function RecentlyViewedHotelsProvider({
  children,
  ...props
}: PropsWithChildren<RecentSearchHotelPropertyResponse>) {
  return (
    <RecentlyViewedHotelsContext.Provider value={props}>
      {children}
    </RecentlyViewedHotelsContext.Provider>
  );
}

export function useRecentlyViewedHotels() {
  const context = useContext(RecentlyViewedHotelsContext);

  if (context === undefined) {
    throw new Error(
      "`RecentlyViewedHotelsContext` could not find any provider"
    );
  }

  return context;
}
